import pathfinder from '@fiverr-private/pathfinder';
import {
    BQ_POPULAR_SERVICE_CLICK_AI_AUTOMATION,
    BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    BQ_POPULAR_SERVICE_CLICK_AUTOMATIONS_AGENTS,
    BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
} from '../../utils/biEvents/events/bigQueryEvents';
import type { ServiceItemType } from '../ServiceItem/types';

const HEADER_LOHP_SOURCE = 'header_lohp';

type PopularService = ServiceItemType;

export const getDefaultPopularServices = (): PopularService[] => [
    {
        elementName: 'website development',
        labelKey: 'logged_out_homepage.subcategory_carousel.website_development.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
    },
    {
        elementName: 'architecture & interior design',
        labelKey: 'logged_out_homepage.subcategory_carousel.architectural_design_services.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    },
    {
        elementName: 'automations & agents',
        labelKey: 'logged_out_homepage.subcategory_carousel.automations_agents.sub',
        href: pathfinder(
            'short_category_nested_sub_category',
            {
                category_id: 'programming-tech',
                id: 'software-development',
                nested_sub_category_id: 'automations-workflows',
            },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_AUTOMATIONS_AGENTS,
    },
    {
        elementName: 'video editing',
        labelKey: 'logged_out_homepage.subcategory_carousel.video_editing.sub',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'video-editing' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    },
    {
        elementName: 'ai automation',
        labelKey: 'logged_out_homepage.subcategory_carousel.ai_automation.sub',
        eventName: BQ_POPULAR_SERVICE_CLICK_AI_AUTOMATION,
        href: pathfinder('discover_ai_agents_page', {}, { query: { source: HEADER_LOHP_SOURCE } }),
    },
];
